import { Controller } from "@hotwired/stimulus";
import moment from "moment";
import "datatables.net-bs5";
import languageNL from "datatables.net-plugins/i18n/nl-NL.js";

$.fn.dataTable.moment = function (format) {
  const types = $.fn.dataTable.ext.type;
  types.detect.unshift(function (d) {
    return moment(d, format, true).isValid() ? "moment-" + format : null;
  });
  types.order["moment-" + format + "-pre"] = function (d) {
    // Handle empty or non-date strings
    if (!d || d === "" || d === "geen datum gekozen") {
      return Infinity; // Sort AFTER all dates
      // return -Infinity; // Use this to sort BEFORE all dates
    }
    const m = moment(d, format, true);
    return m.isValid() ? m.valueOf() : Infinity;
  };
};

$.fn.dataTable.moment("DD-MM-YYYY");

export default class extends Controller {
  static targets = ["table"];
  static values = {
    orderColumn: { type: Number, default: 1 },
    orderDirection: { type: String, default: "desc" },
  };

  connect() {
    this.initializeDataTable();
  }

  disconnect() {
    if (this.table) {
      this.table.destroy();
      this.table = null;
    }
  }

  reload() {
    if (this.table) {
      this.table.draw();
    }
  }

  initializeDataTable() {
    const table_id = this.tableTarget.id;
    if ($.fn.dataTable.isDataTable(`#${table_id}`)) {
      this.table = $(`#${table_id}`).DataTable();
      return;
    }
    this.tableTarget.style.visibility = "hidden";
    let options = this.options();
    this.table = $(`#${table_id}`).DataTable(options);
  }

  options() {
    return {
      language: languageNL,
      searching: false,
      order: [[this.orderColumnValue, this.orderDirectionValue]],
      controls: false,
      paging: false,
      info: false,
      autoWidth: false,
      dom: "t", // Just the table, no wrappers
      initComplete: () => {
        this.tableTarget.style.visibility = "visible";
      },
      columnDefs: [
        { width: "12%", targets: 0 },
        { orderable: false, targets: -1 },
        {
          targets: [0, 1],
          className: "dt-left", // Force left alignment for cells
          // Override default numeric/date alignment
          createdCell: function (td, cellData, rowData, row, col) {
            $(td).css("text-align", "left");
          },
        },
        {
          targets: [1],
          type: "moment-DD-MM-YYYY",
        },
      ],
    };
  }
}
